import * as actionType from "../constants";

const initialState = {
  columns: [],
  loading: false,
  rows: [],
  link: "",
  hidden_columns: [],
  hidden_column_count: 0,
  show_board: false,
  message: "",
  status: "",
  code: "",
  bulk: "",
  isFilterReset: {},
  users: {},
};

const sorting = (a, b) => {
  if (a.sequence < b.sequence) {
    return -1;
  }
};

export const createattributereducer = (state = initialState, action) => {
  switch (action.type) {
    case actionType.ADDING_ATTRIBUTE:
      return {
        ...state,
        loading: true,
      };

    case actionType.FETCHING_ALL_COLUMNS:
      return {
        ...state,
        loading: true,
        columns: [...state.columns],
        rows: [...state.rows],
      };
    case actionType.BULK_UPDATE_PROCESS:
      return { ...state, bulk: 400 };
    case actionType.BULK_UPDATE_DONE:
      return {
        ...state,
        code: action.payload.code,
        message: action.payload.message,
        status: action.payload.title,
        show_board: action.payload.board,
        bulk: action.payload.code,
      };
    case actionType.FETCH_DONE_FOR_COLUMNS:
      return {
        ...state,
        loading: false,
        columns: action.payload.columns,
        // rows: action.payload.rows,

        hidden_column_count: action.payload.hidden_count,
        hidden_columns: action.payload.hidden_columns,
        users: action.payload.users,
      };
    case actionType.FETCH_DONE_FOR_ROWS:
      if (action.payload?.update?.update) {
        return {
          ...state,
          rows: action.payload.rows,
          show_board: true,
          loading: false,
          bulk: 600,
        };
      } else if (action.payload?.update?.cell) {
        return {
          ...state,
          rows: action.payload.rows,
          show_board: true,
          loading: false,
          bulk: 600,
          message: action.payload.update.message,
          status: action.payload.update.status,
          code: action.payload.update.code,
        };
      } else {
        return {
          ...state,
          rows: action.payload.rows,
          show_board: action.payload.board,
          loading: false,
          bulk: 600,
        };
      }

    case actionType.CREATE_ATTRIBUTE:
      const allcols = [...state.columns];
      return {
        ...state,
        loading: false,
        columns: [...state.columns, action.payload],
        show_board: true,
        message: "Tattle attribute created successfully",
        status: "success",
        code: 200,
      };
    case actionType.IS_RESET_FILTER:
      return {
        ...state,
        isFilterReset: { ...action.payload },
      };
    case actionType.ATTRIBUTE_POPUP_DEACTIVE:
      return {
        ...state,
        status: "",
        code: "",
        message: "",
        show_board: false,
      };
    case actionType.ATTRIBUTE_MESSAGE_DEACTIVATE:
      return {
        ...state,
        show_board: false,
        message: "",
        title: "",
        code: "",
      };

    case actionType.SEQUENCE_DONE:
      const data = action.payload.data;
      const sort = data.sort(sorting);
      return {
        ...state,
        columns: [...sort],
        status: action.payload,
        loading: false,
      };
    case actionType.ATTRIBUTE_RENAME_DONE:
      const { actionFields } = action.payload;
      const newrenameol = [...state.columns];
      const fieldkey = action.payload?.data?.field;
      const index = newrenameol.findIndex((keyu) => keyu.field === fieldkey);

      for (const key in actionFields) {
        newrenameol[index][key] = actionFields[key];
        newrenameol[index]["hide"] = action.payload?.data?.hide;
      }
      newrenameol[index]["headerName"] = action.payload.data["headerName"];
      const hiddenColumns = [...state.hidden_columns];
      if (action.payload.hidden) {
        hiddenColumns.push(action.payload.hidden);
      }

      return {
        ...state,
        columns: newrenameol,
        message: action.payload.message,
        code: action.payload.code,
        show_board: true,
        status: action.payload.status,
        hidden_columns: hiddenColumns,
        hidden_column_count: hiddenColumns.length,
      };

    case actionType.DATA_NOT_FOUND:
      return { ...state, columns: action.payload };

    case actionType.LINK_STATUS_CHECK:
      return { ...state, link: action.payload, show_board: false };

    case actionType.HIDE_COLUMN:
      const field = action.payload.field;
      const columnsremo = [...state.columns];
      const newarrayhide = columnsremo.map((item, index) => {
        return field.includes(item.field)
          ? { ...item, hide: true, show_on_column: false }
          : item;
      });

      return {
        ...state,
        columns: newarrayhide,
        hidden_columns: action.payload.data.hidden_columns,
        hidden_column_count: action.payload.hidden_count,
      };
    case actionType.SHOW_COLUMNS:
      const showField = action.payload.attributes;
      const filterShowColumns = state.hidden_columns.find(
        (item) => item.field === showField[0]
      );
      filterShowColumns["show_on_column"] = true;
      filterShowColumns["hide"] = false;
      const showColumns = [...state.columns];
      showColumns.unshift(filterShowColumns);
      return {
        ...state,
        columns: showColumns,
        hidden_columns: action.payload.hidden_columns,
        hidden_column_count: action.payload.hidden_column_count,
      };
  }
  return state;
};
